exports.components = {
  "component---src-templates-content-page-tsx": () => import("./../../../src/templates/content_page.tsx" /* webpackChunkName: "component---src-templates-content-page-tsx" */)
}

